import { render, staticRenderFns } from "./soroteca-localizar.vue?vue&type=template&id=d64935c6&scoped=true&"
import script from "./soroteca-localizar.vue?vue&type=script&lang=js&"
export * from "./soroteca-localizar.vue?vue&type=script&lang=js&"
import style0 from "./soroteca-localizar.vue?vue&type=style&index=0&id=d64935c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64935c6",
  null
  
)

export default component.exports